import {ReportType} from '../../entities/reports/constants';

export function convertStringToReportType(input: string): ReportType {
  switch (input) {
    case 'selection': {
      return ReportType.SELECTION;
    }

    case 'spring': {
      return ReportType.SPRING;
    }

    case 'summer': {
      return ReportType.SUMMER;
    }

    case 'autumn': {
      return ReportType.AUTUMN;
    }

    case 'winter': {
      return ReportType.WINTER;
    }

    case 'entrysheet': {
      return ReportType.ES;
    }

    case 'intern': {
      return ReportType.INTERN;
    }

    default: {
      return ReportType.OTHER;
    }
  }
}
